import { render, staticRenderFns } from "./WhyChooseUs.vue?vue&type=template&id=5d8a8754&scoped=true&"
var script = {}
import style0 from "./WhyChooseUs.vue?vue&type=style&index=0&id=5d8a8754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a8754",
  null
  
)

export default component.exports